// src/components/common/NotFound.jsx
import PageMeta from "../../components/common/PageMeta";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function NotFound() {
  const ballLg = "font-['Gravitas_One'] select-none shrink-0 flex items-center justify-center bg-primary-500 text-base-50 rounded-full w-[clamp(4rem,15vw,10rem)] h-[clamp(4rem,15vw,10rem)] text-[clamp(2rem,8vw,5rem)]";
  return (
    <>
      <PageMeta
        title="404 Not Found"
        description="お探しのページが見つかりませんでした。"
        noindex
      />
      <div className="max-w-2xl mx-auto py-16 px-4 text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-8 flex justify-center gap-1">
          <motion.span
            className={`${ballLg} `}
            initial={{ rotate: -30 }}
            animate={{ rotate: 30 }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
          >4</motion.span>
          <motion.span
            className={`${ballLg} `}
            initial={{ rotate: -30 }}
            animate={{ rotate: [-30, 330, 330, -30, -30] }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
              times: [0, 0.35, 0.5, 0.85, 1],
            }}
          >0</motion.span>
          <motion.span
            className={`${ballLg} `}
            initial={{ rotate: 195 }}
            animate={{ rotate: 165 }}
            transition={{ duration: 1, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
          >4</motion.span>
        </h1>
        <p className="text-primary-500 mb-24">お探しのページが見つかりませんでした。</p>
        <div className="mt-16 mx-auto max-w-sm">
          <Link
            to="/"
            className="block py-2 text-primary-500 border border-primary-500 rounded-xl font-bold bg-base-50 hover:bg-primary-500 hover:text-base-50 transition-colors text-center"
          >
            トップへ戻る
          </Link>
        </div>
      </div>
    </>
  );
}